import { createAsyncThunk } from '@reduxjs/toolkit';

import l10n from '../../shared/strings';
import showBatchOperationStartedToast from '../batchOperations/helpers/showBatchOperationStartedToast';
import { OPERATION_TYPES, RESULT } from '../batchOperations/constants';
import handleStoreDisconnectedError, {
  isStoreDisconnectedError,
} from './helpers/handleStoreDisconnectedError';

const strings = l10n.ACTIONS_TOOLBAR.PRODUCTS;

export const archivePublishedListings = createAsyncThunk(
  'products/archivePublishedListings',
  async ({ productIdsForApi, channelName }, {
    extra: {
      sdk, Toast, Logger,
    },
  }) => {
    try {
      const { data } = await sdk.products.archiveListings({
        productIds: productIdsForApi,
      });

      if (data?.batchId) {
        showBatchOperationStartedToast({
          batchId: data.batchId,
          status: data.status || RESULT.queued,
          total: data.total,
          operationType: data.operationType || OPERATION_TYPES.ARCHIVE_CHANNEL_RECORDS,
          channelName,
        });
        return data;
      }

      Toast(strings.archiveFailed, { type: 'error', autoClose: false });
      throw new Error('Archive batch was not started');
    } catch (error) {
      if (isStoreDisconnectedError(error)) {
        handleStoreDisconnectedError({ Toast, error });
      } else {
        Toast(strings.archiveFailed, { type: 'error', autoClose: false });
      }
      Logger.error(new Error('Bulk archive listings failed'), { error }, [
        'ArchivePublishedListingsFailed',
        { errorMessage: error?.message || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(archivePublishedListings.rejected, (state, { error }) => {
    state.error = error?.message || 'Cannot archive selected listings';
  });
};
